import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Separator, Card, CardContent, Grid, GridColumn, Table, TableCell, TableRow } from 'telia-front-react';
import { Telia1Image } from '../common/Telia1Image';
export const InternetTelia1PromoModal = (props) => {
    const { offer } = props;
    const { translate } = React.useContext(TranslationsContext);
    const renderCardTitle = () => {
        return (React.createElement(CardContent, { background: "brand-primary-bg-subtle" },
            React.createElement(Grid, { noWrap: true, align: ['middle-xs'] },
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Telia1Image, { imageWidth: 80 })),
                React.createElement(GridColumn, { width: ['max'] },
                    React.createElement("h5", null, translate('internetCalculator.telia1PromoModal.tableTitle.fasterSpeed'))))));
    };
    const renderPromoTable = () => {
        return (React.createElement(Table, null,
            React.createElement("thead", null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { padding: "none" }, translate('internetCalculator.telia1PromoModal.table.regularSpeedHeading')),
                    React.createElement(TableCell, null, translate('internetCalculator.telia1PromoModal.table.telia1Heading')))),
            React.createElement("tbody", null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { padding: "none" },
                        translate('internetCalculator.speedUntilTitle'),
                        " ",
                        offer.contractualDownloadSpeed,
                        "/",
                        offer.contractualUploadSpeed,
                        ' ',
                        translate('internetCalculator.downloadSpeedUnit')),
                    React.createElement(TableCell, null,
                        translate('internetCalculator.speedUntilTitle'),
                        ' ',
                        React.createElement("strong", null,
                            offer.downloadSpeed,
                            "/",
                            offer.uploadSpeed,
                            " ",
                            translate('internetCalculator.downloadSpeedUnit')))))));
    };
    const renderTelia1PromoCard = () => {
        return (React.createElement(Card, { type: "light" },
            renderCardTitle(),
            React.createElement(CardContent, { background: "neutral-bg-level-1", padding: { top: 'xsmall', bottom: 'xsmall' } }, renderPromoTable())));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, translate('internetCalculator.telia1PromoModal.description')),
        React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
        renderTelia1PromoCard()));
};
